<template>
  <div>
    <DataLoader :is_on="updating"/>
    <div v-if="isActive" class="notifications-wrapper">
      <div class="notifications-elements-wrapper">
        <div
          v-for="(task, key) in tasks"
          :key="key"
          :class="['kalendar-notifikacija', 'task-'+task.event_type.class_colour]"
        >
          <div class="kalendar-notif-ikona">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="66"
              height="66"
              viewBox="0 0 66 66"
            >
              <g>
                <g>
                  <path
                    fill="#feedf3"
                    d="M33 0c18.225 0 33 14.775 33 33S51.225 66 33 66 0 51.225 0 33 14.775 0 33 0z"
                  />
                </g>
                <g>
                  <path
                    class="kalendar-icon"
                    fill="#fd4087"
                    d="M46.632 23.472v18.95a3.238 3.238 0 0 1-3.238 3.231H22.238A3.238 3.238 0 0 1 19 42.423V23.472a3.238 3.238 0 0 1 3.238-3.23h1.295v-2.154h2.16v2.153H39.94v-2.153h2.159v2.153h1.295a3.238 3.238 0 0 1 3.238 3.23zm-2.159 4.738H21.16v14.213a1.08 1.08 0 0 0 1.08 1.077h21.155a1.08 1.08 0 0 0 1.08-1.077zm0-4.738a1.08 1.08 0 0 0-1.08-1.077H42.1v2.154h-2.16v-2.154H25.693v2.154h-2.159v-2.154h-1.295a1.08 1.08 0 0 0-1.08 1.077v2.584h23.315zM23.102 30.47h2.158v2.153h-2.158zm4.317 0h2.159v2.153h-2.159zm4.318 0h2.158v2.153h-2.158zm4.317 0h2.159v2.153h-2.159zm4.318 0h2.158v2.153h-2.158zm-17.27 4.307h2.158v2.153h-2.158zm4.317 0h2.159v2.153h-2.159zm4.318 0h2.158v2.153h-2.158zm4.317 0h2.159v2.153h-2.159zm-12.952 4.307h2.158v2.153h-2.158zm4.317 0h2.159v2.153h-2.159zm4.318 0h2.158v2.153h-2.158zm4.317 0h2.159v2.153h-2.159zm4.318-4.307h2.158v2.153h-2.158z"
                  />
                </g>
              </g>
            </svg>
          </div>
          <div class="kalendar-notif-info">
            <div :class="'vrsta-eventa event-' + task.event_type.class_colour">
              {{ task.event_type.name }}
            </div>
            <div class="kalendar-notif-title" @click="openPopup(task)">{{ task.title }}</div>
            <div class="vrijeme-lokacija-event">
              <div class="vrijeme-event">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="15"
                  height="16"
                  viewBox="0 0 15 16"
                >
                  <g>
                    <g>
                      <path
                        fill="#606076"
                        d="M15 7.765A7.476 7.476 0 1 1 7.524.289 7.484 7.484 0 0 1 15 7.765zM8.058 3.493a.534.534 0 0 0-1.068 0v3.738H3.252a.534.534 0 0 0 0 1.068h4.272a.534.534 0 0 0 .534-.534z"
                      />
                    </g>
                  </g>
                </svg>
                  <span v-if="task.event_type.uid == 1 || task.event_type.uid == 4">
                    {{getDate(task.start_date_time)}}
                  </span>
                  <span v-else>{{ getSatiEvent(task.start_date_time)
                  }}{{
                    task.start_date_time != task.end_date_time
                      ? " - " + getSatiEvent(task.end_date_time)
                      : ""
                  }}
                  </span>
              </div>
              <div v-if="task.location_address != null" class="lokacija-event">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="17"
                  height="20"
                  viewBox="0 0 17 20"
                >
                  <g>
                    <g>
                      <path
                        fill="#606076"
                        d="M11.314 7.843a2.465 2.465 0 0 1-2.463 2.462A2.465 2.465 0 0 1 6.39 7.843a2.465 2.465 0 0 1 2.462-2.464 2.466 2.466 0 0 1 2.463 2.464zM17 8.15c0 4.404-4.163 8.067-6.4 10.035-.31.274-.58.51-.793.71-.268.25-.612.375-.956.375-.343 0-.687-.125-.955-.375-.214-.2-.482-.436-.793-.71-2.237-1.968-6.4-5.63-6.4-10.035 0-2.177.848-4.223 2.387-5.763A8.094 8.094 0 0 1 8.85 0c2.177 0 4.223.848 5.762 2.387A8.098 8.098 0 0 1 17 8.15zm-4.558-.308c0-1.98-1.61-3.591-3.59-3.591A3.595 3.595 0 0 0 5.26 7.842c0 1.98 1.61 3.592 3.59 3.592 1.98 0 3.591-1.611 3.591-3.592z"
                      />
                    </g>
                  </g>
                </svg>
                  <v-tooltip v-if="task.location_address.length >= 25" right>
                    <template v-slot:activator="{ on, attrs }">
                      <div v-bind="attrs" v-on="on">
                        {{ task.location_address.slice(0, 25) }}...
                      </div>
                    </template>
                    <div class="flex-row">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="17"
                        height="20"
                        viewBox="0 0 17 20"
                      >
                        <g>
                          <g>
                            <path
                              fill="#544EAC"
                              d="M11.314 7.843a2.465 2.465 0 0 1-2.463 2.462A2.465 2.465 0 0 1 6.39 7.843a2.465 2.465 0 0 1 2.462-2.464 2.466 2.466 0 0 1 2.463 2.464zM17 8.15c0 4.404-4.163 8.067-6.4 10.035-.31.274-.58.51-.793.71-.268.25-.612.375-.956.375-.343 0-.687-.125-.955-.375-.214-.2-.482-.436-.793-.71-2.237-1.968-6.4-5.63-6.4-10.035 0-2.177.848-4.223 2.387-5.763A8.094 8.094 0 0 1 8.85 0c2.177 0 4.223.848 5.762 2.387A8.098 8.098 0 0 1 17 8.15zm-4.558-.308c0-1.98-1.61-3.591-3.59-3.591A3.595 3.595 0 0 0 5.26 7.842c0 1.98 1.61 3.592 3.59 3.592 1.98 0 3.591-1.611 3.591-3.592z"
                            />
                          </g>
                        </g>
                      </svg>
                      {{ task.location_address }}
                    </div>
                  </v-tooltip>
                  <div v-else>{{ task.location_address }}</div>
              </div>
            </div>
              <div
                v-if="
                  task.location_name != '' &&
                  task.location_name != null
                "
                class="event-opis-location"
              >
                {{ task.location_name }}
              </div>
              <a v-if="task.is_online" class="event-opis-location"
                :href="task.meeting_url"
                target="_blank"
                style="text-decoration: underline">
                {{ task.meeting_url.length > 45 ? task.meeting_url.slice(0,45)+'...' : task.meeting_url}}
              </a>
              <div class="izvrsi-button" @click="completeTask(task)">Riješeno</div>
            <div class="izvrsi" @click="popByKey(key)">x</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import gsap from "gsap";
import moment from "moment"
import ms_calendar from "@/apiCallers/calendarSharepoint";
import DataLoader from '@/components/generalComponents/DataLoader'
export default {
  props: {
    sioVar: {
      type: Object,
      required: false,
      default: null,
    },
  },
  components:{
    DataLoader
  },
  data() {
    return {
      tasks: [],
      updating:false,
    };
  },
  computed: {
    isActive() {
      return this.tasks.length > 0;
    },
  },
  watch: {
    sioVar: function () {
      if (this.sioVar != null) {
        this.sioVar.socket.on("first tasks", (data) => {
          this.tasks = [];
          this.tasks = JSON.parse(data);
        });
      }
    },
    $route (to, from){
        if(to != from){
          this.tasks=[];
        }
    },
    tasks : function()
    {
      if(this.tasks.length == 0)
      {
        this.$store.state.notifies_shown = false;
        this.closeBlur()
      }
      else{
        this.$store.state.notifies_shown = true;
        this.activateBlur()
      }
    },
  },
  methods: {
    popByKey(key) {
      this.tasks.splice(key, 1);
    },
    closeBlur() {
      gsap.to(".router-wrapper", 0.5, { filter: "none", opacity:1 });
      gsap.to(".navigation", 0.5, { pointerEvents: "auto" });
    },
    activateBlur() {
      gsap.to(".router-wrapper", 0.5, { filter: "blur(5px)", opacity:0.2 });
      gsap.to(".navigation", 0.5, { pointerEvents: "none" });
    },
    openPopup(event) {
      // this.closeBlur();
      setTimeout(() => {
        this.$store.state.event_details.popup_open = true;
        this.$store.state.event_details.chosen_event = event;
        let tl = gsap.timeline();
        tl.to(".notifications-wrapper", 0.2, {
          opacity: 0
        });
        tl.to(".notifications-wrapper", 0, {
          display: "none"
        });
      }, 100);
      
    },
    getSatiEvent(fullDateTime) {
      return moment(fullDateTime).format("LT");
    },
    getDate(date){
      return moment(date).format("DD.MM.yyyy.");
    },
    async completeTask(task){
      console.log(task);
      this.updating = true;
      await ms_calendar.editEventBucketStatus(task.uid, task.personal_event != undefined ?'personal' : 'case_event',0).then((resp)=>{
        this.updating = false;
        this.tasks = this.tasks.filter((ts)=>ts.uid != task.uid);
      }).catch((err)=>{});
    }
  },
  mounted() {
  },
};
</script>